export const toEstimateNumber = (value: unknown): number | null => {
  if (value == null || value === '' || Array.isArray(value)) {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
